






































































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

// @ts-ignore
import * as FileSaver from 'file-saver';
import {IFullOptions, json2csv, json2csvAsync} from 'json-2-csv';

import {Notify} from '@/utils/Notify';
import {LogLevel, LogLevelMetadata, UserLogService} from '@/model/system/log/UserLog';
import SystemLogStore from '@/store/system/SystemLogs.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({})
export default class SystemUserLogs extends Mixins<BaseComponent>(BaseComponent) {
  private logStore: SystemLogStore = getModule(SystemLogStore, this.$store);

  private levels: string[] = [];
  private levelFilter: LogLevel = LogLevel.Debug;

  private serviceFilter: UserLogService | null = null;

  private search: string = '';
  private searchDebounced: string = '';
  private debounceTimer: any;

  private footerConfig = {
    itemsPerPageOptions: [50, 100, 200, 500],
  };
  private itemsPerPage: number = this.footerConfig.itemsPerPageOptions[0];

  private expanded: any[] = [];

  private locale = navigator.language;

  private levelsMetadata: { [key: string]: LogLevelMetadata } = {
    [LogLevel.Emergency]: new LogLevelMetadata('Emergency', 0, 'black'),
    [LogLevel.Alert]: new LogLevelMetadata('Alert', 1, 'purple'),
    [LogLevel.Critical]: new LogLevelMetadata('Critical', 2, 'pink'),
    [LogLevel.Error]: new LogLevelMetadata('Error', 3, 'red'),
    [LogLevel.Warning]: new LogLevelMetadata('Warning', 4, 'orange'),
    [LogLevel.Notice]: new LogLevelMetadata('Notice', 5, 'blue'),
    [LogLevel.Information]: new LogLevelMetadata('Informational', 6, 'blue-grey'),
    [LogLevel.Debug]: new LogLevelMetadata('Debugging', 7, 'grey'),
  };

  private userLogHeaders = [
    {
      text: 'Category',
      value: 'Category',
      width: 100,
      align: 'center',
      sortable: false,
    },
    {
      text: 'Severity',
      value: 'Level',
      width: 100,
      align: 'center',
      sortable: false,
      filter: (level: LogLevel) => {
        return this.levelsMetadata[level].index <= this.levelsMetadata[this.levelFilter].index;
      },
      sort: (a: LogLevel, b: LogLevel): number => {
        return this.levelsMetadata[a].index - this.levelsMetadata[b].index;
      },
    },
    {
      text: 'Service',
      value: 'Service',
      sortable: false,
      sort: (a: any, b: any): number => {

        if (a.uid === undefined) {
          a.uid = 0;
        }

        if (b.uid === undefined) {
          b.uid = 0;
        }

        return b.uid - a.uid;
      },
      filter: (service: UserLogService) => {
        if (this.serviceFilter === null) {
          return true;
        }

        return service.Uid === this.serviceFilter.Uid;
      },
    },
    {
      text: 'Time',
      value: 'Id',
      width: 200,
    },
    {
      text: 'Message',
      value: 'Message',
      sortable: false,
    },
    {
      text: '',
      value: 'data-table-expand',
    },
  ];

  private refreshing: boolean = false;

  private async mounted() {

    for (const level in LogLevel) {
      this.levels.push(level);
    }

    await this.refresh();
  }

  private async refresh() {
    try {
      this.refreshing = true;
      await this.logStore.fetchUserLogs();
    } catch (error) {
      Notify.Error(this.logger, `Could not get user logs`, error);
    } finally {
      this.refreshing = false;
    }
  }

  private debounceSearch() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.searchDebounced = this.search;
    }, 500);
  }

  private setServiceFilter(service: UserLogService) {
    this.logger.info(`Settings service filter`, service);
    this.serviceFilter = service;
  }

  private exportJson() {
    const blob = new Blob([JSON.stringify(this.logStore.UserLogs)], {type: 'text/plain;charset=utf-8'});
    FileSaver.saveAs(blob, 'log.json');
  }

  private async exportCsv() {
    try {
      const option: IFullOptions = {
        emptyFieldValue: '',
        delimiter: {
          field: ';',
        },
      };

      if (this.logStore.UserLogs) {
        const csv = await json2csvAsync(this.logStore.UserLogs, option);
        const blob = new Blob([csv], {type: 'text/plain;charset=utf-8'});
        FileSaver.saveAs(blob, 'log.csv');
      }

    } catch (error) {
      Notify.Error(this.logger, `Could not export user logs`, error);
    }
  }
}
